/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputReadStoreStats
 */
export interface OutputReadStoreStats {
    /**
     * 
     * @type {boolean}
     * @memberof OutputReadStoreStats
     */
    initialized: boolean;
    /**
     * 
     * @type {string}
     * @memberof OutputReadStoreStats
     */
    lastReloadedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputReadStoreStats
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OutputReadStoreStats
     */
    rowsNumber: number;
}

/**
 * Check if a given object implements the OutputReadStoreStats interface.
 */
export function instanceOfOutputReadStoreStats(value: object): boolean {
    if (!('initialized' in value)) return false;
    if (!('name' in value)) return false;
    if (!('rowsNumber' in value)) return false;
    return true;
}

export function OutputReadStoreStatsFromJSON(json: any): OutputReadStoreStats {
    return OutputReadStoreStatsFromJSONTyped(json, false);
}

export function OutputReadStoreStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputReadStoreStats {
    if (json == null) {
        return json;
    }
    return {
        
        'initialized': json['initialized'],
        'lastReloadedAt': json['lastReloadedAt'] == null ? undefined : json['lastReloadedAt'],
        'name': json['name'],
        'rowsNumber': json['rowsNumber'],
    };
}

export function OutputReadStoreStatsToJSON(value?: OutputReadStoreStats | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'initialized': value['initialized'],
        'lastReloadedAt': value['lastReloadedAt'],
        'name': value['name'],
        'rowsNumber': value['rowsNumber'],
    };
}

